import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterTab, { FilterTabItem } from 'components/common/FilterTab';
import SearchBox from 'components/common/SearchBox';
import { Proceso } from 'data/project-management/procesos';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import { ChangeEvent, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useAuth } from 'providers/AuthProvider';

interface ProcesosTopSectionInterface {
  activeView: 'list' | 'board' | 'card';
}

const ProcesosTopSection = ({ activeView }: ProcesosTopSectionInterface) => {
  // 1. Move useAuth inside the component
  const { user } = useAuth();
  
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext<Proceso>();

  const handleFilterItemClick = (columnId: string, value: string) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'TODOS' ? '' : value);
  };

  const counts = useMemo(() => {
    const rows = getPrePaginationRowModel().rows;
    const countMap: { [key: string]: number } = {
      TODOS: rows.length,
      FAM: 0,
      EA: 0,
      IS: 0,
      ISV: 0,
      LA: 0,
      MSJ: 0,
      ZCC: 0,
      '': 0,
    };

    rows.forEach(({ original: { MIEM } }) => {
      const key = MIEM || '';
      countMap[key] = (countMap[key] || 0) + 1;
    });

    return countMap;
  }, [getPrePaginationRowModel().rows]);

  const tabItems: FilterTabItem[] = useMemo(() => {
    // Return empty array if not socio, though we will handle visibility in JSX
    if (user?.nivel_acceso !== 'socio') return [];

    return [
      { label: 'TODOS', value: 'TODOS', onClick: () => handleFilterItemClick('MIEM', 'TODOS'), count: counts.TODOS },
      { label: 'FAM', value: 'FAM', onClick: () => handleFilterItemClick('MIEM', 'FAM'), count: counts.FAM },
      { label: 'EA', value: 'EA', onClick: () => handleFilterItemClick('MIEM', 'EA'), count: counts.EA },
      { label: 'IS', value: 'IS', onClick: () => handleFilterItemClick('MIEM', 'IS'), count: counts.IS },
      { label: 'ISV', value: 'ISV', onClick: () => handleFilterItemClick('MIEM', 'ISV'), count: counts.ISV },
      { label: 'LA', value: 'LA', onClick: () => handleFilterItemClick('MIEM', 'LA'), count: counts.LA },
      { label: 'MSJ', value: 'MSJ', onClick: () => handleFilterItemClick('MIEM', 'MSJ'), count: counts.MSJ },
      { label: 'ZCC', value: 'ZCC', onClick: () => handleFilterItemClick('MIEM', 'ZCC'), count: counts.ZCC },
      { label: 'SIN ASIGNAR', value: '', onClick: () => handleFilterItemClick('MIEM', ''), count: counts[''] },
    ];
  }, [counts, user]); 

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      {/* 2. Conditional Rendering: Only show the FilterTab column if user is socio */}
      {user?.nivel_acceso === 'socio' && (
        <Col xs={12} sm="auto">
          <FilterTab tabItems={tabItems} />
        </Col>
      )}
      
      {/* 3. Keep SearchBox visible for everyone, but adjust Col size if tabs are missing */}
      <Col xs={12} sm={user?.nivel_acceso === 'socio' ? 'auto' : 12}>
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Buscar"
            style={{ maxWidth: user?.nivel_acceso === 'socio' ? '30rem' : '100%' }}
            className="me-3 w-100"
          />
        </div>
      </Col>
    </Row>
  );
};

export default ProcesosTopSection;